export const FILEREADER = 'FileReader'
export const FILEWRITER = 'FileWriter'

const asIfReaderWriter = {
  reader: FILEREADER,
  writer: FILEWRITER
}

export default asIfReaderWriter
